// src/js/privacy/privacyConsent.js
(function() {
  const CLARIP_COOKIE_NAME_PRIMARY = window.muradClaripCookieName ?? "murad-us.myshopify_clarip_consent";
  const CLARIP_COOKIE_NAME_SECONDARY = "murad_clarip_consent";
  const PRIVACY_DEFAULT = window.muradPrivacyDefault ?? "deny_all";
  const CLARIP_CATORIES_REQUIRED_FOR_DY = [1, 3];
  const CLARIP_CATORIES_REQUIRED_FOR_GERMANY_YOTPO = [2];
  const CLARIP_COOKIE_VAL_TO_CLARIP_CATEGORY = {
    0: "strictly_necessary",
    1: "advertising",
    2: "functional",
    3: "analytics"
  };
  const CLARIP_CATEGORY_TO_SHOPIFY_CATEGORY = {
    advertising: ["marketing", "sale_of_data"],
    functional: ["preferences"],
    analytics: ["analytics"]
  };
  const SHOPIFY_CONSENT_TERMS = {
    consent: true,
    deny: false
  };
  const CLARIP_CATEGORY_TO_GOOGLE_CATEGORY = {
    // "security_storage" is always granted as Clarip is currently configured;
    strictly_necessary: ["security_storage"],
    advertising: [
      "ad_personalization",
      "ad_storage",
      "ad_user_data",
      "personalization_storage"
    ],
    functional: ["functionality_storage"],
    analytics: ["analytics_storage"]
  };
  const GOOGLE_CONSENT_TERMS = {
    consent: "granted",
    deny: "denied"
  };
  function getCookieValue(cookieName) {
    return document.cookie.split("; ").find((row) => row.startsWith(cookieName))?.split("=")[1];
  }
  function getClaripConsentNumericArrayDefault() {
    if (PRIVACY_DEFAULT === "allow_all") {
      return { isDefault: true, consentArray: [0, 1, 2, 3] };
    } else {
      return { isDefault: true, consentArray: [0] };
    }
  }
  function getClaripConsentNumericArray() {
    const claripCookieVal = getCookieValue(CLARIP_COOKIE_NAME_PRIMARY) ?? getCookieValue(CLARIP_COOKIE_NAME_SECONDARY);
    if (!claripCookieVal) {
      return getClaripConsentNumericArrayDefault();
    }
    return {
      isDefault: false,
      consentArray: claripCookieVal.split(",").map((stringVal) => parseInt(stringVal))
    };
  }
  function getClaripCookieData() {
    const claripCookieRes = getClaripConsentNumericArray();
    const consentArrayString = claripCookieRes.consentArray.map(
      (val) => CLARIP_COOKIE_VAL_TO_CLARIP_CATEGORY[val]
    );
    return {
      ...claripCookieRes,
      consentArrayString
    };
  }
  function createGoogleDataLayerPayload(cookieData) {
    const { isDefault, consentArrayString } = cookieData;
    let consentSetType = "default";
    if (!isDefault) {
      consentSetType = "update";
    }
    const consentVals = {};
    for (const key in CLARIP_CATEGORY_TO_GOOGLE_CATEGORY) {
      const consentCategories = CLARIP_CATEGORY_TO_GOOGLE_CATEGORY[key];
      if (consentArrayString.includes(key)) {
        consentCategories.forEach((category) => {
          consentVals[category] = GOOGLE_CONSENT_TERMS.consent;
        });
      } else {
        consentCategories.forEach((category) => {
          consentVals[category] = GOOGLE_CONSENT_TERMS.deny;
        });
      }
    }
    return { consentSetType, consentVals };
  }
  function createShopifyConsentPayload(cookieData) {
    const { consentArrayString } = cookieData;
    const consentVals = {};
    for (const key in CLARIP_CATEGORY_TO_SHOPIFY_CATEGORY) {
      const consentCategories = CLARIP_CATEGORY_TO_SHOPIFY_CATEGORY[key];
      if (consentArrayString.includes(key)) {
        consentCategories.forEach((category) => {
          consentVals[category] = SHOPIFY_CONSENT_TERMS.consent;
        });
      } else {
        consentCategories.forEach((category) => {
          consentVals[category] = SHOPIFY_CONSENT_TERMS.deny;
        });
      }
    }
    return consentVals;
  }
  function pushConsentToDataLayer(googleDataLayerPayload = {}) {
    const { consentSetType, consentVals } = googleDataLayerPayload;
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("consent", consentSetType, consentVals);
  }
  function setShopifyCustomerPrivacyAPI(payload) {
    window.Shopify?.customerPrivacy.setTrackingConsent(payload, () => {
    });
  }
  function loadShopifyCustomerPrivacyAPI(payload) {
    window.Shopify?.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1"
        }
      ],
      (error) => {
        if (error) {
          console.error("loadShopifyCustomerPrivacyAPI error", error);
        } else {
          setShopifyCustomerPrivacyAPI(payload);
        }
      }
    );
  }
  function handleShopifyCustomerPrivacyAPI(payload) {
    if (window.Shopify?.customerPrivacy) {
      setShopifyCustomerPrivacyAPI(payload);
    } else {
      loadShopifyCustomerPrivacyAPI(payload);
    }
  }
  function doesClaripConsentAllowDY() {
    const claripConsentNumericArray = getClaripConsentNumericArray();
    return CLARIP_CATORIES_REQUIRED_FOR_DY.every(
      (category) => claripConsentNumericArray.consentArray.includes(category)
    );
  }
  function doesClaripConsentAllowGermanyYotpo() {
    const claripConsentNumericArray = getClaripConsentNumericArray();
    return CLARIP_CATORIES_REQUIRED_FOR_GERMANY_YOTPO.every(
      (category) => claripConsentNumericArray.consentArray.includes(category)
    );
  }
  function dySetInitialConsent() {
    const CHECK_LIMIT = 10;
    let checkCount = 0;
    const intervalSetDYConsent = setInterval(() => {
      if (window.DY?.userActiveConsent) {
        clearInterval(intervalSetDYConsent);
        const claripConsentAllowDY = doesClaripConsentAllowDY();
        window.DY.userActiveConsent = { accepted: claripConsentAllowDY };
      }
      checkCount++;
      if (checkCount >= CHECK_LIMIT) {
        clearInterval(intervalSetDYConsent);
      }
    }, 50);
  }
  function handlePrivacyFallback() {
    const cookieData = getClaripCookieData();
    const googleDataLayerPayload = createGoogleDataLayerPayload(cookieData);
    pushConsentToDataLayer(googleDataLayerPayload);
    const shopifyConsentPayload = createShopifyConsentPayload(cookieData);
    handleShopifyCustomerPrivacyAPI(shopifyConsentPayload);
  }
  function simulateClaripCookieManagerClick() {
    window.scrollTo(0, document.body.scrollHeight);
    claripCookieManager.setToggle();
    claripCookieManager.postGpcDetectedSignal();
    claripCookieManager.showClaripCookieManager();
    "1" === claripCookieManager.$scanCookiesRealTime && claripCookieManager.executeLiveScan();
  }
  function hideYotpoPDPReviewsGermany() {
    const claripConsentAllowGermanyYotpo = doesClaripConsentAllowGermanyYotpo();
    if (!claripConsentAllowGermanyYotpo) {
      const yotpoReviews = document.querySelectorAll(
        "#yotpo-reviews-section-data"
      );
      const placeholder = document.createElement("div");
      const placeholderSpan = document.createElement("span");
      placeholderSpan.textContent = 'Produktbewertungen und Fragen & Antworten sind aufgrund Ihrer Datenschutzeinstellungen nicht verf\xFCgbar. Um sie zu sehen, aktivieren Sie "Funktionale Cookies" in den ';
      const placeholderLink = document.createElement("a");
      placeholderLink.href = "#";
      placeholderLink.textContent = "Cookie Management Tool";
      placeholderLink.style.textDecoration = "underline";
      placeholderLink.addEventListener("click", (event) => {
        event.preventDefault();
        simulateClaripCookieManagerClick();
      });
      placeholder.append(placeholderSpan, placeholderLink);
      placeholder.classList.add(
        "px-4",
        "lg:px-16",
        "eyebrow-1",
        "text-text-primary",
        "text-center",
        "mb-8"
      );
      yotpoReviews.forEach((review) => {
        review.style.display = "none";
        review.parentNode.appendChild(placeholder);
      });
    }
  }
  function handleDynamicYield() {
    dySetInitialConsent();
  }
  function init() {
    if (window.muradUsePrivacyFallback === true) {
      handlePrivacyFallback();
    }
    if (window.muradPrivacySupplement_dy === true) {
      handleDynamicYield();
    }
    if (window.muradPrivacySupplement_germany === true) {
      hideYotpoPDPReviewsGermany();
    }
  }
  init();
})();
